module.exports = __webpack_public_path__ + "img/alpha3.ee182127.png";